import {
  EntityType,
  filterSupportedEntities,
  isSupportedEntityType,
} from "@/queries/folder-entities/types";

export { filterSupportedEntities, isSupportedEntityType };

const ENTITY_LABELS: Record<EntityType, { singular: string; plural: string }> = {
  [EntityType.FOLDER]: { singular: "Folder", plural: "Folders" },
  [EntityType.PROMPT]: { singular: "Prompt", plural: "Prompts" },
  [EntityType.WORKFLOW]: { singular: "Workflow", plural: "Workflows" },
  [EntityType.DATASET]: { singular: "Dataset", plural: "Datasets" },
  [EntityType.REPORT]: { singular: "Evaluation", plural: "Evaluations" },
  [EntityType.AB_TEST]: { singular: "A/B Test", plural: "Releases" },
  [EntityType.SNIPPET]: { singular: "Snippet", plural: "Snippets" },
  [EntityType.INPUT_VARIABLE_SET]: {
    singular: "Input Variable Set",
    plural: "Input Variable Sets",
  },
  [EntityType.SKILL_COLLECTION]: {
    singular: "Skill Collection",
    plural: "Skill collections",
  },
  [EntityType.SMART_TABLE]: { singular: "Table", plural: "Tables" },
  [EntityType.TOOL]: {
    singular: "Tool",
    plural: "Tools",
  },
};

export const getEntitySingularLabel = (type: EntityType) => ENTITY_LABELS[type]?.singular ?? "Item";

export const getEntityPluralLabel = (type: EntityType) => ENTITY_LABELS[type]?.plural ?? "Items";
